import { useState, useEffect } from "react";
import { fetchData } from "./api";
import {  datetime, RRule  } from 'rrule';
import { DateTime } from "luxon";

export const useFetchData = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDataFromApi = async () => {
      let page = 1;
      let resultMax = 100;
      let resultCount = 100; //set before flattenEvents so recurring events dont mess it up.
      let allData = [];
      while ((resultCount == resultMax) && (page < 5)) { // we check that they equal each other because that means we're getting the max results each time, so there could be another page
        try {
          const paginatedUrl = url.includes('per_page') ? `${url}&page=${page}` : url;
          const result = await fetchData(paginatedUrl);
          if(paginatedUrl.includes('/wp-json/wp/v2/ec_event')) { // might need to modify this in the future to check if a URL has per_page instead of targeting the ec_event route. but for now whatever lol
            let updatedEvents = handleEventData(result);
            resultCount = result.length;
            // updatedEvents = flattenEvents(updatedEvents);
            allData = allData.concat(updatedEvents);
          } else {
            allData = result;
            break;
          } 
        } catch (error) {
          setError(error);
        }
        page++;
      }
      setLoading(false);
      setData(allData);
    };
    fetchDataFromApi();
  }, [url]);

  const handleEventData = (eventArray) => {
    return eventArray.map(item => {
      const calData = {
        id:         item.id,
        title:      item.title['rendered'],
        start:      '',
        end:        '',
        noend:      false,
        allDay:     false,
        desc:       item.acf['ec_date_display'],
        content:    item.content['rendered'],
        link:       item.acf['ec_link'],
        phone:      item.acf['ec_phone'],
        // link2:       item.acf['ec_link_2'],
        // image:      (item.acf['ec_pdf_url'] != '') ? item.acf['ec_pdf_url'] : '',
        image:      '/wp-content/uploads/2026/04/calendar-location-placeholder.jpg',
        // location:   item.event_location[0],
        // category:   item.event_type,
        // recurs:     (item.event_format.includes(8)) ? true : false,
        // price:      item.acf['ec_price'],
        // recurring:  {
        //   period:   item.acf['ec_period'],
        //   weekday:  item.acf['ec_weekday'],
        //   until:    item.acf['ec_date_until'],
        // },
        rrule:      null
      };

      if(calData.image == '') {
        switch(calData.location) {
          case 23: // linksman
            calData.image = '/wp-content/uploads/2025/02/calendar-linksman.jpg';
            break;
          case 24: // proshop
            calData.image = '/wp-content/uploads/2025/02/calendar-pro-shop.jpg';
            break;
          case 20: // rustic grill
            calData.image = '/wp-content/uploads/2025/02/calendar-rustic-grill.jpg';
            break;
          case 21: // stonewater golf course
            calData.image = '/wp-content/uploads/2025/02/calendar-golf-course.jpg';
            break;
          case 22: // great room
            calData.image = '/wp-content/uploads/2025/02/calendar-the-great-room.jpg';
            break;
          case 25: // the lawn
            calData.image = '/wp-content/uploads/2025/02/calendar-the-lawn.jpg';
            break;
          case 19: // the yard
            calData.image = '/wp-content/uploads/2025/02/calendar-the-yard.jpg';
            break;
          case 18: // stonewater
          default:
            calData.image = '/wp-content/uploads/2025/02/calendar-stonewater.jpg';
            break;
        }
      }

      // Format date time
      let time      = item.acf['ec_time'];
      let timeEnd   = item.acf['ec_time_end'];
      let timeZone  = "-05:00";
      if(calData.recurs)
        timeZone = "-00:00";
      if(time == '' || time == null) {
        time = "00:00:00";
        calData.allDay = true;
      }
      if (timeEnd == '' || timeEnd == null) {
        timeEnd = "23:59:59";
        calData.noend = true;
      }
      
      if(item.acf['ec_date'] == null) {
        calData.start = new Date();
        item.acf['ec_date'] = calData.start;
      }
      else
        calData.start = new Date(`${item.acf['ec_date'].substring(0,4)}-${item.acf['ec_date'].substring(4,6)}-${item.acf['ec_date'].substring(6,8)}T${time}`);

      if(item.acf['ec_date_end'] == null || item.acf['ec_date_until'] != null)
        calData.end = new Date(`${item.acf['ec_date'].substring(0,4)}-${item.acf['ec_date'].substring(4,6)}-${item.acf['ec_date'].substring(6,8)}T${timeEnd}`);
      else
        calData.end = new Date(`${item.acf['ec_date_end'].substring(0,4)}-${item.acf['ec_date_end'].substring(4,6)}-${item.acf['ec_date_end'].substring(6,8)}T${timeEnd}`);

      return calData;
    });
  }

  const flattenEvents = (newEventArray) => {
    const recurArray = newEventArray.map(
      event => event.rrule
    ).filter(Boolean).flat();

    return newEventArray.concat(recurArray);
  }
  
  return { data, loading, error }
}